import {OutsourcedXWaysSymbol} from "./XWaysSymbol";
import {OutsourcedSymbol, SymbolArgs} from "./OutsourcedSymbol";
import {MaxWinSymbol} from "./MaxWinSymbol";
import {XNudgeSymbol} from "./XNudgeSymbol";

export class OutsourcedSymbolFactory {
    // might add spine and sprite pools later on

    constructor() {
    }

    createSymbol(args:SymbolArgs):OutsourcedSymbol {
        let newSymbol:OutsourcedSymbol;
        switch(args.symbolName) {
            case "XN":
                newSymbol = new XNudgeSymbol(args);
                break;
            case "XW":
                newSymbol = new OutsourcedXWaysSymbol(args);
                break;
            case "MAX":
                newSymbol = new MaxWinSymbol(args);
                break;
            default:
                newSymbol = new OutsourcedSymbol(args);
                break;

        }
        return newSymbol;
    }
}
